"use client";
import { useAppStore } from "@/stores";
import { usePermissions } from "@/hooks/use-permissions";
import { AddBalance } from "./add-balance";

/**
 * Global mount for AddBalance, driven by Zustand `addBalanceOpen` state.
 * Mounted once in the dashboard layout; opened by `SubscriptionGateDialog`'s
 * "Add Balance Instead" CTA on the expired_account_action variant.
 *
 * UI-CHROME-ONLY — does not gate any server endpoint. canManageBilling
 * gate is defense-in-depth; the gate dialog already hides the Add Balance
 * CTA for non-billing seats.
 */
export function GlobalAddBalance() {
  const addBalanceOpen = useAppStore((s) => s.addBalanceOpen);
  const closeAddBalance = useAppStore((s) => s.closeAddBalance);
  const addBalancePayload = useAppStore((s) => s.addBalancePayload);
  const { canManageBilling } = usePermissions();

  if (!canManageBilling) return null;

  return (
    <AddBalance
      open={addBalanceOpen}
      onClose={closeAddBalance}
      canManageBilling={canManageBilling}
      defaultAmount={addBalancePayload?.amount}
      source={addBalancePayload?.source}
      onSuccess={() => addBalancePayload?.onSuccess?.()}
    />
  );
}
